import type {AnalyticsDiscoverJobSearchActions} from 'src/action-creators/analytics/analytics-discover-job-search';
import {
  SET_DISCOVER_JOB_SEARCH_CURRENT_DASHBOARD_ID,
  RECEIVE_DISCOVER_JOB_SEARCH_WORKFLOWS_TABLE_COLUMNS,
  RECEIVE_DISCOVER_JOB_SEARCH_CHATBOT_TABLE_COLUMNS,
  RECEIVE_DISCOVER_JOB_SEARCH_NODES_TABLE_COLUMNS,
} from 'src/action-creators/analytics/analytics-discover-job-search';


type FilterColumns = {
  table_columns: Array<string>;
};

export type AnalyticsDiscoverJobSearchState = {
  currentDashboardID: string | null | undefined;
  workflowsTableColumnFilter: FilterColumns | null;
  chatbotTableColumnFilter: FilterColumns | null;
  nodesTableColumnFilter: FilterColumns | null;
};

const initialState: AnalyticsDiscoverJobSearchState = {
  currentDashboardID: null,
  workflowsTableColumnFilter: null,
  chatbotTableColumnFilter: null,
  nodesTableColumnFilter: null,
};

export default (
  state: AnalyticsDiscoverJobSearchState = initialState,
  action: AnalyticsDiscoverJobSearchActions,
): AnalyticsDiscoverJobSearchState => {
  switch (action.type) {
    case SET_DISCOVER_JOB_SEARCH_CURRENT_DASHBOARD_ID: {
      return {
        ...state,
        currentDashboardID: action.payload,
      };
    }
    case RECEIVE_DISCOVER_JOB_SEARCH_WORKFLOWS_TABLE_COLUMNS: {
      return {
        ...state,
        workflowsTableColumnFilter: {
          table_columns: action.payload.columns.table_columns,
        },
      };
    }
    case RECEIVE_DISCOVER_JOB_SEARCH_CHATBOT_TABLE_COLUMNS: {
      return {
        ...state,
        chatbotTableColumnFilter: {
          table_columns: action.payload.columns.table_columns,
        },
      };
    }
    case RECEIVE_DISCOVER_JOB_SEARCH_NODES_TABLE_COLUMNS: {
      return {
        ...state,
        nodesTableColumnFilter: {
          table_columns: action.payload.columns.table_columns,
        },
      };
    }
  }
  return state;
};
